import { useEffect, useState } from "react";

/** @typedef {IntersectionObserverInit & {stopObserve: boolean}} IntersectionObserverArgs */
/** @typedef {import('react').RefObject<Element>} Ref */

/**
 * @param {Ref} ref
 * @param {IntersectionObserverArgs} observerParams
 * @returns {{entry: IntersectionObserverEntry | null}}
 */
export const useIntersectionObserver = (
  ref,
  { root = null, rootMargin = "0px", threshold = 0, stopObserve = false } = {}
) => {
  /** @type {[IntersectionObserverEntry | null, React.Dispatch<React.SetStateAction<IntersectionObserverEntry | null>>]} state */
  const [entry, setEntry] = useState(null);

  const frozen = entry?.isIntersecting && stopObserve;

  /** @param {[IntersectionObserverEntry]} updatedEntry */
  const updateEntry = ([updatedEntry]) => {
    setEntry(updatedEntry);
  };

  useEffect(() => {
    const node = ref?.current;

    if (!node || frozen) return;

    const observerParams = { root, rootMargin, threshold };

    const observer = new IntersectionObserver(updateEntry, observerParams);

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [frozen, ref, root, rootMargin, threshold]);

  return entry;
};
